import React from 'react';
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer, Label } from 'recharts';
const Dashboard = () => {
  // Mock data for metrics
  const metricsData = {
    totalTicketsIssued: 156,
    totalReconciled: '$245,800.00',
    outstandingReconciliation: '$78,500.00'
  };
  // Mock data for line chart
  const ticketsByWeekData = [{
    week: 'Week 1',
    tickets: 24,
    amount: 36000
  }, {
    week: 'Week 2',
    tickets: 32,
    amount: 48000
  }, {
    week: 'Week 3',
    tickets: 18,
    amount: 27000
  }, {
    week: 'Week 4',
    tickets: 42,
    amount: 63000
  }, {
    week: 'Week 5',
    tickets: 30,
    amount: 45000
  }, {
    week: 'Week 6',
    tickets: 10,
    amount: 15000
  }];
  // Mock data for pie chart
  const reconciliationStatusData = [{
    name: 'Matched',
    value: 98,
    color: '#10B981'
  }, {
    name: 'Mismatched',
    value: 23,
    color: '#F59E0B'
  }, {
    name: 'Unreconciled',
    value: 35,
    color: '#EF4444'
  }];
  // Mock data for bar chart
  const topAirlinesData = [{
    name: 'SQ',
    tickets: 42,
    revenue: 63000
  }, {
    name: 'QR',
    tickets: 36,
    revenue: 54000
  }, {
    name: 'EK',
    tickets: 28,
    revenue: 42000
  }, {
    name: 'CX',
    tickets: 22,
    revenue: 33000
  }, {
    name: 'MH',
    tickets: 18,
    revenue: 27000
  }];
  return <div className="space-y-6" data-id="element-1470">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1471">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1472">Dashboard</h1>
      </div>
      {/* Metrics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1473">
        <div className="bg-white shadow rounded-lg p-6" data-id="element-1474">
          <div className="flex items-center" data-id="element-1475">
            <div className="flex-shrink-0 bg-blue-100 rounded-md p-3" data-id="element-1476">
              <svg className="h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" data-id="element-1477">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" data-id="element-1478" />
              </svg>
            </div>
            <div className="ml-5" data-id="element-1479">
              <p className="text-sm font-medium text-gray-500 truncate" data-id="element-1480">
                Total Tickets Issued
              </p>
              <p className="mt-1 text-3xl font-semibold text-gray-900" data-id="element-1481">
                {metricsData.totalTicketsIssued}
              </p>
              <p className="text-sm text-gray-500" data-id="element-1482">This month</p>
            </div>
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-6" data-id="element-1483">
          <div className="flex items-center" data-id="element-1484">
            <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-1485">
              <svg className="h-8 w-8 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" data-id="element-1486">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1487" />
              </svg>
            </div>
            <div className="ml-5" data-id="element-1488">
              <p className="text-sm font-medium text-gray-500 truncate" data-id="element-1489">
                Total Amount Reconciled
              </p>
              <p className="mt-1 text-3xl font-semibold text-gray-900" data-id="element-1490">
                {metricsData.totalReconciled}
              </p>
              <p className="text-sm text-green-500" data-id="element-1491">Fully matched</p>
            </div>
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-6" data-id="element-1492">
          <div className="flex items-center" data-id="element-1493">
            <div className="flex-shrink-0 bg-red-100 rounded-md p-3" data-id="element-1494">
              <svg className="h-8 w-8 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" data-id="element-1495">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1496" />
              </svg>
            </div>
            <div className="ml-5" data-id="element-1497">
              <p className="text-sm font-medium text-gray-500 truncate" data-id="element-1498">
                Outstanding Reconciliation
              </p>
              <p className="mt-1 text-3xl font-semibold text-gray-900" data-id="element-1499">
                {metricsData.outstandingReconciliation}
              </p>
              <p className="text-sm text-red-500" data-id="element-1500">Pending reconciliation</p>
            </div>
          </div>
        </div>
      </div>
      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1501">
        {/* Line Chart */}
        <div className="bg-white shadow rounded-lg p-6" data-id="element-1502">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1503">
            Tickets Issued Over Time
          </h3>
          <div className="h-80" data-id="element-1504">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1505">
              <LineChart data={ticketsByWeekData} margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 25
            }} data-id="element-1506">
                <CartesianGrid strokeDasharray="3 3" data-id="element-1507" />
                <XAxis dataKey="week" tick={{
                fontSize: 12
              }} data-id="element-1508">
                  <Label value="Week" position="insideBottom" offset={-20} style={{
                  textAnchor: 'middle',
                  fontSize: 12
                }} data-id="element-1509" />
                </XAxis>
                <YAxis yAxisId="left" tick={{
                fontSize: 12
              }} data-id="element-1510">
                  <Label value="Tickets" angle={-90} position="insideLeft" style={{
                  textAnchor: 'middle',
                  fontSize: 12
                }} data-id="element-1511" />
                </YAxis>
                <YAxis yAxisId="right" orientation="right" tick={{
                fontSize: 12
              }} data-id="element-1512">
                  <Label value="Amount ($)" angle={90} position="insideRight" style={{
                  textAnchor: 'middle',
                  fontSize: 12
                }} data-id="element-1513" />
                </YAxis>
                <RechartsTooltip formatter={(value, name) => {
                if (name === 'amount') return [`$${value}`, 'Revenue'];
                return [value, 'Tickets'];
              }} data-id="element-1514" />
                <Legend data-id="element-1515" />
                <Line yAxisId="left" type="monotone" dataKey="tickets" stroke="#3B82F6" strokeWidth={2} activeDot={{
                r: 8
              }} name="Tickets" data-id="element-1516" />
                <Line yAxisId="right" type="monotone" dataKey="amount" stroke="#10B981" strokeWidth={2} activeDot={{
                r: 8
              }} name="amount" data-id="element-1517" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        {/* Bar Chart */}
        <div className="bg-white shadow rounded-lg p-6" data-id="element-1518">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1519">
            Top 5 Airlines by Volume
          </h3>
          <div className="h-80" data-id="element-1520">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1521">
              <BarChart data={topAirlinesData} margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 25
            }} data-id="element-1522">
                <CartesianGrid strokeDasharray="3 3" data-id="element-1523" />
                <XAxis dataKey="name" tick={{
                fontSize: 12
              }} data-id="element-1524">
                  <Label value="Airline" position="insideBottom" offset={-20} style={{
                  textAnchor: 'middle',
                  fontSize: 12
                }} data-id="element-1525" />
                </XAxis>
                <YAxis yAxisId="left" tick={{
                fontSize: 12
              }} data-id="element-1526">
                  <Label value="Tickets" angle={-90} position="insideLeft" style={{
                  textAnchor: 'middle',
                  fontSize: 12
                }} data-id="element-1527" />
                </YAxis>
                <YAxis yAxisId="right" orientation="right" tick={{
                fontSize: 12
              }} data-id="element-1528">
                  <Label value="Revenue ($)" angle={90} position="insideRight" style={{
                  textAnchor: 'middle',
                  fontSize: 12
                }} data-id="element-1529" />
                </YAxis>
                <RechartsTooltip formatter={(value, name) => {
                if (name === 'revenue') return [`$${value}`, 'Revenue'];
                return [value, 'Tickets'];
              }} data-id="element-1530" />
                <Legend data-id="element-1531" />
                <Bar yAxisId="left" dataKey="tickets" fill="#3B82F6" name="Tickets" data-id="element-1532" />
                <Bar yAxisId="right" dataKey="revenue" fill="#10B981" name="revenue" data-id="element-1533" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        {/* Pie Chart */}
        <div className="bg-white shadow rounded-lg p-6 lg:col-span-2" data-id="element-1534">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1535">
            Reconciliation Status
          </h3>
          <div className="h-80 flex items-center justify-center" data-id="element-1536">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1537">
              <PieChart data-id="element-1538">
                <Pie data={reconciliationStatusData} cx="50%" cy="50%" labelLine={true} outerRadius={120} fill="#8884d8" dataKey="value" label={({
                name,
                percent
              }) => `${name}: ${(percent * 100).toFixed(0)}%`} data-id="element-1539">
                  {reconciliationStatusData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1540" />)}
                </Pie>
                <RechartsTooltip formatter={(value, name, props) => {
                return [`${value} tickets`, name];
              }} data-id="element-1541" />
                <Legend data-id="element-1542" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
};
export default Dashboard;